import axios from "axios";
import { Apis, BaseUrl } from "../../config";

import { getSession } from "../authActions";
import { toast } from "react-toastify";

export const exploreFacility = (values) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();
  const { svc_provider_name, svc_type_id, iso_city_id, iso_cntry_id } = values;
  dispatch({ type: "FETCH_DATA_REQUEST" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.facilitylist}typCityCntry/?svc_type_id=${svc_type_id}&iso_city_id=${iso_city_id}&iso_cntry_id=${iso_cntry_id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { svc_provider_name: svc_provider_name, sys_user_id: user_profile_id, role_id: role_id },

      }
    );
    dispatch({ type: "FETCH_DATA_SUCCESS", payload: response.data });
    const { rec } = response.data.usr
    if (rec.length > 0) {
      toast.success("Facilities found");
    } else {
      toast.error("Facilities NOT found!");
    }
  } catch (error) {
    dispatch({
      type: "FETCH_DATA_FAILURE",
      payload: error.response.data,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const resetState = () => async (dispatch) => {
  dispatch({ type: "Reset_State" });
};
